var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[(_vm.loading)?_c('div',{staticClass:"loading-page"},[_c('a-spin',{staticStyle:{"width":"100%","height":"100%"}})],1):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }